import UnitPageShell from '../../components/shared/UnitPageShell';
import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { tokens } from '../../theme/tokens';
// removed unused imports (useTTS, EditableTextBlock, ZoomableImage)
import {
  Typography,
  Box,
  Paper,
  List,
  ListItemButton,
  ListItemText,
  Divider,
  Fab
} from '@mui/material';

import HomeIcon from '@mui/icons-material/Home';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Link as RouterLink } from 'react-router-dom';

const subCategories = [
  { title: '6.1 Ventilatoren', route: '/units/m6_u1_ventilatoren' },
  { title: '6.2 Pumpen', route: '/units/m6_u2_pumpen' },
  { title: '6.3 Ventilantriebe', route: '/units/m6_u3_ventilantriebe' },
  { title: '6.4 Klappenantriebe', route: '/units/m6_u4_klappenantriebe' },
  { title: '6.5 Sensoren', route: '/units/m6_u5_sensoren' },
  { title: '6.6 Sicherheit', route: '/units/m6_u6_sicherheit' },
  { title: '6.7 Schaltschrank', route: '/units/m6_u7_schaltschrank' }
];

const M6_Geraete_Bauteile: React.FC = () => {
  const { darkMode } = useTheme();
  
  return (
  <UnitPageShell title="6 Geräte & Bauteile">
    <Box sx={{ minHeight: '100vh', position: 'relative', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(7, 20, 42, 0.35)', pointerEvents: 'none' }} />
      <Box sx={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: '#FFFFFF', color: darkMode ? tokens.colors.dark.text : '#0D3559', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
        <Box sx={{ position: 'relative', zIndex: 1, px: { xs: 2, md: 3 }, py: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>6 Geräte & Bauteile</Typography>
        </Box>
      </Box>
      <Box sx={{ flex: 1, position: 'relative', zIndex: 1, p: { xs: 2.5, md: 4 }, display: 'flex', justifyContent: 'center' }}>
        <Paper sx={{ width: '100%', maxWidth: 780, backgroundColor: 'rgba(255,255,255,0.94)', borderRadius: 3, boxShadow: '0 18px 40px rgba(10, 31, 68, 0.25)' }}>
          <List disablePadding>
            {subCategories.map((item, index) => (
              <React.Fragment key={item.route}>
                {index > 0 && <Divider sx={{ borderColor: 'rgba(13,53,89,0.12)' }} />}
                <ListItemButton component={RouterLink} to={item.route} sx={{ py: 2.5, px: { xs: 2.5, md: 3.5 }, '&:hover': { backgroundColor: 'rgba(13,53,89,0.08)' } }}>
                  <ListItemText primary={item.title} primaryTypographyProps={{ variant: 'h6', fontWeight: 600, color: darkMode ? tokens.colors.dark.text : '#0D3559' }} />
                  <ChevronRightIcon sx={{ color: '#B2140F' }} />
                </ListItemButton>
              </React.Fragment>
            ))}
          </List>
        </Paper>
      </Box>
      <Fab component={RouterLink} to="/" sx={{ position: 'fixed', bottom: 16, right: 16, backgroundColor: '#B2140F', color: '#ffffff', '&:hover': { backgroundColor: tokens.colors.primaryHover } }} aria-label="Zur Startseite">
        <HomeIcon />
      </Fab>
    </Box>
  </UnitPageShell>
  );
};

export default M6_Geraete_Bauteile;

